<template>
  <div id="app">
    <myheader></myheader>
    <router-view/>
  </div>
</template>

<script>

import myheader from './components/myheader'
import Loading from './components/Loading.vue'

export default {
  name: 'App',
  components: {
    myheader,
    Loading
  }
}
</script>

<style>

a {
    margin:0;
    padding:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
}

* {
  margin: 0;
  margin-top: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.sim, .help{
  margin-left: 2%;
  margin-right: 2%;
  margin-top: 2%;
}
a {
  cursor: pointer;
}
table.resultlist tr:hover {
  background-color: #FFCC99;    /* マウスオーバー時の行の背景色 */
}
table.resultlist td:hover {
  background-color: #FFAA77;    /* マウスオーバー時のセルの背景色 */
}
tr:nth-child(2n+1) {
    background: #F0FFFF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue